import {Button, Form, Input, Modal, Select, Space, Upload} from 'antd';
import {SettingOutlined, UploadOutlined} from '@ant-design/icons';
import {
    ALLOWED_LOWER_BOUND,
    DEFAULT_CONFIGURATIONS, DEFAULT_MODEL,
    getRemoteData,
    mapColumns,
    OUTLIER_LOWER_BOUND,
    populateConfigs
} from "./Util";
import PdbFormConfiguration from './Configuration';
import React, {useContext, useState} from "react";
import {ConfigContext} from "./App";

const onFinishFailed = (errorInfo) => {
    console.error('Failed:', errorInfo);
};

function PdbForm({ updateData, setFileName, setPymolUrl, setLoadingState, setDynamicColumns, setUploadedFile, setModel }) {

    const [file, setFile] = useState(null);
    const [isPdbIdDisable, setPdbIdDisable] = useState(false);
    const [advancedQueryBuilder, setAdvancedQueryBuilder] = useState(DEFAULT_CONFIGURATIONS);
    const [isModalOpen, setModalOpen] = useState(false);
    const {setOutlierLowerBound, setAllowedLowerBound, ..._} = useContext(ConfigContext);

    const error = (errorMessage) => {
        Modal.error({
            title: 'Request Failed',
            content: errorMessage,
        });
    };

    const onFinish = async (values) => {
        setLoadingState(true)
        let response
        let downloadFileName
        values['configurations'] = populateConfigs(advancedQueryBuilder)
        if(file!==null){
            setUploadedFile(file)
            const formData = new FormData();
            formData.append("pdb_file", file)
            formData.append("model",values["model"])
            formData.append("configurations",JSON.stringify(values['configurations']))
            downloadFileName = file.name
            response = await getRemoteData(formData, true)
        }else {
            downloadFileName = values['pdb_id']['text']
            response = await getRemoteData(JSON.stringify({
                ...values,
                "pdb_id":  values['pdb_id']['text'],
            }), false)
        }
        if (response.isSuccess) {
            updateData(response.data)
            setPymolUrl(response.pymolUrl)
            setFileName(downloadFileName)
            setDynamicColumns(mapColumns(advancedQueryBuilder));
            setModel(values["model"])
        }
        else {
            updateData([])
            setModel(values["model"])
            error(response.data)
        }
        setLoadingState(false)
    }
    const [form] = Form.useForm();
    return (
        <>
            <PdbFormConfiguration
                isModalOpen={isModalOpen}
                setModalOpen={setModalOpen}
                advancedQueryBuilder={advancedQueryBuilder}
                setAdvancedQueryBuilder={(queryBuilder)=>{
                    setAdvancedQueryBuilder(queryBuilder)
                }}
                OkButtonText = "OK"
                setAllowDownload={null}
            />

            <Form name="basic"
                  form={form}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed} autoComplete="off"
                  initialValues={{ "model": DEFAULT_MODEL }}>
                <Form.Item required label="PDB ID">
                    <div style={{ marginBottom: 0, display: 'flex', flexDirection:'row', gap: 20}} >
                        <Form.Item name={['pdb_id', 'text']} style={{marginBottom: 0, width:100 }}
                                   rules={isPdbIdDisable ? [] : [
                                       {
                                           required: true,
                                           message: 'Input PDB ID',
                                       },
                                       {
                                           max: 4,
                                           message: 'Input 4 character entry'
                                       },
                                       {
                                           min: 4,
                                           message: 'Input 4 character entry'
                                       },
                                       {
                                           message: 'Invalid PDB entry',
                                           validator: (_, value) => {
                                               if (value.length === 4) {
                                                   if (/[0-9][A-Za-z0-9]{3}/.test(value)) {
                                                       return Promise.resolve();
                                                   }
                                                   return Promise.reject();
                                               }
                                               return Promise.resolve();
                                           }
                                       }
                                   ]}>
                            <Space.Compact>
                                <Input style={{marginBottom:0}} disabled={isPdbIdDisable} placeholder="eg: 1hho" maxLength={4} />
                            </Space.Compact>
                        </Form.Item>
                        <Form.Item name={['pdb_id', 'file']} style={{ marginBottom: 0 }}>
                            <Upload
                                maxCount={1}
                                onRemove= {(file) => {setFile(null); setPdbIdDisable(false);}}
                                beforeUpload={ (fileData) => {setFile(fileData); setPdbIdDisable(true);
                                    form.resetFields([["pdb_id","text"]]);
                                    return false}}
                                file
                            >
                                <Button icon={<UploadOutlined />}>Select File</Button>
                            </Upload>
                        </Form.Item>
                    </div>
                </Form.Item>
                <Form.Item
                    style={{  width: 400, marginTop: 25 }}
                    label="Use mixture models inferred from"
                    name="model"
                    rules={[
                        {
                            required: true,
                            message: '',
                        }
                    ]}>
                    <Select
                        options={[{ value: 'Top2018', label: 'Top2018: Williams et al. (2022) Protein Science, 31(1):290-300'}, { value: 'PDB50HighRes', label: 'PDB50HighRes: Amarasinghe et al. (2023) Bioinformatics, 39(S_1):i357–i367' }]} />

                </Form.Item>
                <Form.Item
                    style={{ display: 'flex'}}
                    name="configurations"
                    label="Advanced Query Builder"
                >
                    <Button icon={<SettingOutlined />} onClick={()=>{setModalOpen(true)}}>Customize</Button>
                </Form.Item>

                <Form.Item wrapperCol={{ span: 12, }} style={{ display: 'flex'}}>
                    <Space>
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                        <Button type="default" onClick={()=>{form.resetFields([["pdb_id","text"], "upload"]);
                            setFile(null)
                            setFileName("")
                            setUploadedFile(null)
                            form.resetFields([["pdb_id","file"]]);
                            setPdbIdDisable(false);
                            updateData([]);
                            setModel(DEFAULT_MODEL)
                            setDynamicColumns(mapColumns(DEFAULT_CONFIGURATIONS));
                            setAdvancedQueryBuilder(DEFAULT_CONFIGURATIONS);
                            setOutlierLowerBound(OUTLIER_LOWER_BOUND)
                            setAllowedLowerBound(ALLOWED_LOWER_BOUND)
                        }}>
                            Reset
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </>
    )
}
export default PdbForm;